module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('h2', [_vm._v(_vm._s(_vm.$t('invitationRecords')))]), _vm._v(" "), _c('div', {
    staticClass: "invite-banner"
  }, [_c('div', {
    staticClass: "content-box",
    attrs: {
      "id": "friend-num"
    }
  }, [_c('div', {
    staticClass: "content"
  }, [_c('p', {
    staticClass: "little-title"
  }, [_vm._v(_vm._s(_vm.$t('inviteFriends')))]), _vm._v(" "), _c('p', {
    staticClass: "main-num"
  }, [_vm._v(_vm._s(_vm.user.invitation_count))]), _vm._v(" "), _c('p', {
    staticClass: "unit"
  }, [_vm._v(_vm._s(_vm.user.invitation_count <= 1 ? _vm.$tc('referrals', 1) : _vm.$tc('referrals', 2)))]), _vm._v(" "), _c('p', {
    staticClass: "explain"
  }, [_vm._v(_vm._s(_vm.$t('numDescribe')))])])]), _vm._v(" "), _c('div', {
    staticClass: "content-box",
    attrs: {
      "id": "reward-days"
    }
  }, [_c('div', {
    staticClass: "content"
  }, [_c('p', {
    staticClass: "little-title"
  }, [_vm._v(_vm._s(_vm.$t('reward')))]), _vm._v(" "), _c('p', {
    staticClass: "main-num"
  }, [_vm._v(_vm._s(_vm.user.award_days))]), _vm._v(" "), _c('p', {
    staticClass: "unit"
  }, [_vm._v(_vm._s(_vm.user.award_days <= 1 ? _vm.$tc('days', 1) : _vm.$tc('days', 2)))]), _vm._v(" "), _c('p', {
    staticClass: "explain"
  }, [_vm._v(_vm._s(_vm.$t('instructions')))])])]), _vm._v(" "), _c('div', {
    staticClass: "content-box",
    attrs: {
      "id": "invite-friend-box"
    }
  }, [_c('invite-friend', {
    attrs: {
      "id": "invite-code-box",
      "invitation-code": _vm.user.invitation_code
    }
  })], 1)]), _vm._v(" "), _c('p', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('invite-record')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-09b5717a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/affiliate/IndexMain.vue
// module id = 1260
// module chunks = 1